import {
  history_repository,
} from '@/repositories';

const actions = {
  async searchHistory(_, criteria) {
    const history_list = await history_repository.searchHistory(criteria);

    return history_list;
  },

  async searchHistoryByCriteriaObject(_, criteria) {
    const history_list = await history_repository.searchHistoryByCriteriaObject(criteria);

    return history_list;
  },

  async createHistory(_, criteria) {
    const created_history = await history_repository.createHistory(criteria);

    return created_history;
  },
};

export default {
  actions,
  namespaced: true,
};
